<template>
  <div class="statistics">
    <div class="statistics2">
      <div class="statisticsi">
        <statistics_item title="今日成交额" :config="config" type="up">
        </statistics_item>
      </div>
      <div class="statisticsi">
        <statistics_item title="成交总金额" :config="config2" type="up">
        </statistics_item>
      </div>
    </div>
    <div class="statistics2">
      <div class="statisticsi">
        <statistics_item dw="辆" title="在场车辆" :config="config3" type="up">
        </statistics_item>
      </div>
      <div class="statisticsi">
        <statistics_item dw="个" title="停车场数量" :config="config4" type="down">
        </statistics_item>
      </div>
    </div>
  </div>
</template>

<script>
import statistics_item from "_c/home/left/statistics_item";

export default {
  name: "statistics",
  components: {statistics_item},
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: '',
      config: {
        number: [383232],
        textAlign: 'left',
        animationFrame: 60,
        style: {
          fontSize: 20,
          fill: 'rgba(1, 192, 90, 1)',
        }
      },
      config2: {
        number: [32277064],
        textAlign: 'left',
        style: {
          fontSize: 20,
          fill: 'rgba(254, 209, 41, 1)',
        }
      },
      config3: {
        number: [4569960],
        textAlign: 'left',
        style: {
          fontSize: 20,
          fill: 'rgba(119, 240, 255, 1)',
        }
      },
      config4: {
        number: [373],
        textAlign: 'left',
        style: {
          fontSize: 20,
          fill: 'rgba(136, 82, 246, 1)',
        }
      },
    }
  },
  watch: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.statistics2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  height: 50%;
}

.statistics {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;

  .statisticsi {
    width: calc(50% - 10px);
  }
}
</style>
